import { alpha, Button, styled, Switch } from '@mui/material'

interface MovieceptionErrorButtonProps {
  label: string
  onClick?: () => void
  disabled?: boolean
}

interface MovieceptionCancelButtonProps {
  label: string
  onClick?: () => void
  disabled?: boolean
}

interface MovieceptionPrimaryButtonProps {
  label: string
  onClick?: () => void
  disabled?: boolean
}

const ErrorButtonBase = styled(Button)(({ theme }) => ({
  '&:hover': {
    borderColor: theme.palette.error.main,
    backgroundColor: theme.palette.action.hover,
  },
}))

const CancelButtonBase = styled(Button)(({ theme }) => ({
  '&:hover': {
    borderColor: theme.palette.secondary.main,
    backgroundColor: theme.palette.action.hover,
  },
}))

const PrimaryButtonBase = styled(Button)(({ theme }) => ({
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}))

// Brand-colored outlined button (burgundy border AND text), matching the
// native settings Data buttons exactly.
const OutlinedButtonBase = styled(Button)(({ theme }) => ({
  color: theme.palette.brand.main,
  borderColor: theme.palette.brand.main,
  '&:hover': {
    borderColor: theme.palette.brand.main,
    backgroundColor: theme.palette.action.hover,
  },
}))

export const MovieceptionErrorButton: React.FC<
  MovieceptionErrorButtonProps
> = ({ label, onClick, disabled }) => {
  return (
    <ErrorButtonBase
      variant='outlined'
      color='error'
      size='small'
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </ErrorButtonBase>
  )
}

export const MovieceptionCancelButton: React.FC<
  MovieceptionCancelButtonProps
> = ({ label, onClick, disabled }) => {
  return (
    <CancelButtonBase
      variant='outlined'
      color='secondary'
      size='small'
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </CancelButtonBase>
  )
}

export const MovieceptionPrimaryButton: React.FC<
  MovieceptionPrimaryButtonProps
> = ({ label, onClick, disabled }) => {
  return (
    <PrimaryButtonBase
      variant='contained'
      color='primary'
      size='small'
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </PrimaryButtonBase>
  )
}

export const MovieceptionOutlinedButton: React.FC<
  MovieceptionPrimaryButtonProps
> = ({ label, onClick, disabled }) => {
  return (
    <OutlinedButtonBase
      variant='outlined'
      size='small'
      onClick={onClick}
      disabled={disabled}
    >
      {label}
    </OutlinedButtonBase>
  )
}

export const MovieceptionSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase': {
    '&:hover': {
      backgroundColor: alpha(theme.palette.text.primary, 0.06),
    },

    '&.Mui-checked': {
      color: theme.palette.primary.main,

      '&:hover': {
        backgroundColor: alpha(theme.palette.primary.main, 0.12),
      },

      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.primary.main,
        opacity: 0.6,
      },
    },
  },

  '& .MuiSwitch-track': {
    backgroundColor: theme.palette.divider,
    opacity: 1,
    borderRadius: 13,
  },
}))
